import { createContext, useContext } from 'react';

export interface AdminUser {
  email: string;
  [key: string]: unknown;
}

export const AdminContext = createContext<{
  adminUser: AdminUser | null;
  logout: () => void;
}>({
  adminUser: null,
  logout: () => {},
});

export const useAdminContext = () => useContext(AdminContext);
